const pages = {
  home: {
    hero: {
      subtitle: "策略性能源採購顧問",
      title: "原油與LNG專業解決方案",
      titleHighlight: "採購",
      description: "Medigreen LLC 提供原油與LNG採購的專業顧問服務。我們結合深厚的市場專業知識與全球網絡，為能源採購者帶來最佳成果。",
      ctaPrimary: "探索我們的服務",
      ctaSecondary: "免費諮詢",
    },
    services: {
      sectionTitle: "我們的服務",
      title: "全方位解決方案",
      titleHighlight: "for 能源採購",
      description: "從市場情報到合約執行，Medigreen 提供全方位的顧問服務，協助您優化能源採購策略。",
      cta: "查看所有服務",
      items: {
        crudeOil: {
          title: "原油採購",
          desc: "提供原油採購的端到端顧問服務——從供應商識別與市場分析到合約談判與物流協調。",
        },
        lng: {
          title: "LNG採購策略",
          desc: "全面的LNG採購支援，包括長期合約結構設計、現貨市場優化和價格風險管理。",
        },
        market: {
          title: "市場分析與預測",
          desc: "專有的數據驅動分析，涵蓋全球能源市場、價格趨勢和供需動態，為採購決策提供資訊。",
        },
        contract: {
          title: "合約談判支援",
          desc: "在複雜的能源合約談判中提供專家指導，確保有利條款、風險緩解和法規遵循。",
        },
      },
    },
    about: {
      sectionTitle: "關於 Medigreen LLC",
      title: "信賴夥伴",
      titleHighlight: "for 您的能源採購",
      description1: "Medigreen LLC 是一家專注於原油與LNG採購顧問的專業諮詢公司。我們結合深厚的市場知識和嚴謹的分析能力，協助能源採購者達成最佳採購成果。",
      description2: "我們的資深專業團隊在國際能源市場、供應鏈管理和合約法方面擁有數十年的經驗——為客戶在採購談判中提供決定性的競爭優勢。",
      cta: "了解更多關於我們",
      badge: {
        label: "全球網絡",
        value: "40+",
        sublabel: "國家與地區",
      },
      strengths: {
        global: {
          title: "全球網絡",
          desc: "連接中東、東南亞、澳洲和美洲的供應商與交易對手。",
        },
        risk: {
          title: "風險管理",
          desc: "針對您業務需求量身定制的全面價格風險和供應安全策略。",
        },
        team: {
          title: "專家團隊",
          desc: "在國際能源交易和採購方面擁有20多年實務經驗的顧問。",
        },
      },
    },
    stats: {
      years: "產業經驗年數",
      deals: "諮詢的採購交易",
      clients: "全球能源客戶",
      value: "採購總值（美元）",
    },
    cta: {
      badge: "聯絡我們",
      title: "解決",
      titleHighlight: "Your 能源挑戰",
      heading: "準備好優化您的能源採購了嗎？",
      description: "無論您是在波動的原油市場中導航，還是建構長期LNG合約，Medigreen 的專家都準備好協助您。我們的首次諮詢是免費的。",
      benefits: [
        "免費初步諮詢",
        "量身定制的採購策略",
        "接觸全球供應商網絡",
        "持續的市場情報支援",
      ],
      button: "預約免費諮詢",
    },
    news: {
      sectionTitle: "最新新聞",
      title: "市場洞察與更新",
      cta: "查看所有新聞",
    },
  },
  services: {
    hero: {
      subtitle: "我們的業務",
      title: "我們的服務",
      description: "全面的能源採購顧問服務，旨在協助您在原油與LNG市場中達成最佳成果。",
    },
    items: {
      crudeOil: {
        title: "原油採購顧問",
        desc: "我們提供全面的原油採購顧問服務，涵蓋供應商識別、市場分析、價格基準測試和合約談判。",
        features: ["供應商識別與資格認證", "價格基準測試與市場分析", "合約結構設計與談判", "物流與運輸協調", "品質檢驗支援"],
      },
      lng: {
        title: "LNG採購策略",
        desc: "我們的LNG顧問服務協助買家導航複雜的全球LNG市場。",
        features: ["長期合約結構設計", "現貨與短期貨物採購", "價格公式優化", "目的地靈活性談判", "再氣化終端顧問"],
      },
      market: {
        title: "市場分析與價格預測",
        desc: "Medigreen 專有的分析框架提供可執行的市場情報。",
        features: ["週度與月度市場報告", "價格情境建模", "供應中斷風險評估", "需求展望分析", "競爭對手採購基準測試"],
      },
      contract: {
        title: "合約談判支援",
        desc: "我們經驗豐富的談判人員與您的團隊並肩工作，確保有利的合約條款。",
        features: ["條款清單審查與起草", "價格審查條款談判", "不可抗力與責任條款", "爭議解決機制", "法規遵循審查"],
      },
      risk: {
        title: "供應鏈風險管理",
        desc: "我們協助客戶識別、評估和緩解其能源採購投資組合中的供應鏈風險。",
        features: ["供應安全評估", "交易對手信用風險分析", "地緣政治風險監測", "應急供應計劃", "保險與避險顧問"],
      },
      regulatory: {
        title: "法規與合規顧問",
        desc: "導航國際能源貿易的複雜法規環境需要專業知識。",
        features: ["進出口法規指導", "制裁合規篩查", "環境標準顧問", "碳足跡評估", "政府聯絡支援"],
      },
    },
    cta: {
      title: "準備開始了嗎？",
      description: "今天就聯絡我們進行免費初步諮詢，了解 Medigreen 如何轉變您的能源採購策略。",
      button: "聯絡我們",
    },
  },
  about: {
    hero: {
      subtitle: "我們是誰",
      title: "關於 Medigreen LLC",
      description: "一家建立在專業知識、誠信和對客戶成果不懈關注基礎上的專業能源採購顧問公司。",
    },
    story: {
      subtitle: "我們的故事",
      title: "建立在深厚產業專業知識之上",
      paragraphs: [
        "Medigreen LLC 的成立是為了解決能源市場中的一個關鍵缺口：能源買家在導航複雜的原油與LNG採購世界時，對真正獨立、專業顧問服務的需求。",
        "使我們與眾不同的是我們產業網絡的廣度和深度。通過多年與全球生產商、貿易商、金融家和監管機構的接觸而建立的網絡，為客戶提供直接接觸機會和洞察的途徑。",
        "通過利用這個廣泛的網絡，Medigreen 提供的服務超越了建議——我們打開大門、促進介紹、推動成果。",
      ],
      cta: "與我們合作",
    },
    values: {
      subtitle: "我們的價值觀",
      title: "驅動我們的力量",
      items: {
        integrity: { title: "誠信", desc: "我們以完全的透明度運作，始終為客戶的最佳利益行事。" },
        expertise: { title: "專業", desc: "深厚的市場知識和在全球能源市場數十年的實務經驗。" },
        global: { title: "全球觸及", desc: "與全球供應商、貿易商和交易對手建立的關係。" },
        results: { title: "結果導向", desc: "我們通過為客戶利潤提供的實質價值來衡量成功。" },
      },
    },
    company: {
      subtitle: "公司資訊",
      title: "我們的辦公室",
      address: "地址",
      phone: "電話",
      email: "電子郵件",
    },
    team: {
      subtitle: "我們的團隊",
      title: "認識團隊",
      members: {
        yasunori: {
          name: "Yasunori Kawauchi",
          title: "創辦人兼執行長",
          bio: "一位經驗豐富的領導者，在全球能源生產商、貿易商和金融機構之間擁有廣泛的網絡。",
        },
        kevin: {
          name: "Kevin Yamazaki",
          title: "創辦人兼技術長",
          bio: "Kevin帶來了數位基礎設施和數據驅動市場情報方面的深厚專業知識。",
        },
      },
    },
  },
  contact: {
    hero: {
      subtitle: "保持聯繫",
      title: "聯絡我們",
      description: "準備好優化您的能源採購了嗎？聯絡我們進行免費初步諮詢。",
    },
    info: {
      subtitle: "我們的辦公室",
      title: "讓我們開始對話",
      description: "我們歡迎尋求專業採購顧問支援的能源買家、公用事業和工業公司的詢問。",
      items: {
        address: "地址",
        phone: "電話",
        email: "電子郵件",
        hours: "營業時間",
      },
      hoursValue: "週一至週五：上午9點 – 下午6點（查莫羅標準時間）",
    },
    form: {
      title: "發送訊息給我們",
      name: "全名 *",
      namePlaceholder: "王小明",
      email: "電子郵件地址 *",
      emailPlaceholder: "xiaoming@company.com",
      company: "公司",
      companyPlaceholder: "您的公司名稱",
      subject: "主旨",
      subjectOptions: [
        { value: "", label: "選擇主題..." },
        { value: "Crude Oil Procurement", label: "原油採購" },
        { value: "LNG Procurement", label: "LNG採購" },
        { value: "Market Analysis", label: "市場分析" },
        { value: "Contract Negotiation", label: "合約談判" },
        { value: "General Inquiry", label: "一般詢問" },
      ],
      message: "訊息 *",
      messagePlaceholder: "告訴我們您的能源採購需求...",
      charCount: "{count}/500",
      charError: "訊息不能超過500個字元。",
      submit: "發送訊息",
      sending: "發送中...",
      error: "發生錯誤。請再試一次。",
      success: {
        title: "訊息已發送！",
        description: "感謝您的聯繫。我們將在1個工作日內回覆您。",
      },
    },
  },
  news: {
    hero: {
      subtitle: "保持知情",
      title: "新聞與洞察",
      description: "來自 Medigreen 團隊的市場情報、產業分析和公司更新。",
    },
    articles: {
      readMore: "閱讀更多",
    },
  },
  caseStudies: {
    hero: {
      subtitle: "經證實的成果",
      title: "案例研究",
      description: "真實客戶的真實成果。探索 Medigreen 如何在能源採購項目中提供可衡量的價值。",
    },
    cta: {
      title: "成為我們的下一個成功故事",
      description: "讓 Medigreen 協助您在能源採購策略中實現可衡量的成果。",
      button: "開始對話",
    },
  },
  notFound: {
    title: "找不到頁面",
    description: "您要找的頁面不存在或已被移動。",
    button: "返回首頁",
  },
  privacy: {
    hero: {
      subtitle: "法律資訊",
      title: "隱私權政策",
      updated: "最後更新：2026年4月3日",
    },
    sections: [
      { title: "1. 簡介", content: "Medigreen LLC（以下簡稱「我們」）致力於保護您的個人資訊。本隱私權政策說明我們在您造訪網站或使用顧問服務時，如何收集、使用、揭露及保護您的資訊。" },
      { title: "2. 我們收集的資訊", content: "當您填寫聯絡表單、申請諮詢或透過電子郵件與我們溝通時，我們可能會收集您自願提供的個人資訊，包括姓名、電子郵件地址、公司名稱、電話號碼及能源採購需求等。" },
      { title: "3. 資訊使用方式", content: "我們使用收集的資訊來回應您的詢問並提供顧問服務、發送相關市場洞察和更新（經您同意）、改善我們的網站和服務、遵守適用法律法規，以及保護我們的合法權益。" },
      { title: "4. 資訊共享", content: "未經您的同意，我們不會將您的個人資訊出售、交易或轉讓給第三方，但提供服務所必需、履行法律義務或保護我們的權利所必要的情況除外。" },
      { title: "5. 資料安全", content: "我們實施適當的技術和組織措施，以防止您的個人資訊遭到未授權存取、更改、揭露或破壞。但網際網路上的傳輸方式並非100%安全，我們無法保證絕對的安全性。" },
      { title: "6. Cookie", content: "我們的網站可能使用Cookie和類似的追蹤技術來增強您的瀏覽體驗。您可以設定瀏覽器拒絕所有Cookie，但這可能導致網站某些功能無法正常運作。" },
      { title: "7. 第三方連結", content: "我們的網站可能包含第三方網站的連結。我們對這些網站的隱私慣例或內容不承擔責任，建議您查閱所訪問第三方網站的隱私政策。" },
      { title: "8. 您的權利", content: "根據您所在地區，您可能對個人資訊享有特定權利，包括存取、更正或刪除資料的權利。如需行使這些權利，請聯絡 info@medigreen.energy。" },
      { title: "9. 政策變更", content: "我們可能會不時更新本隱私權政策。我們將透過在本頁面發布新政策並更新日期來通知您任何變更。您在任何變更後繼續使用我們的網站，即表示您接受新政策。" },
      { title: "10. 聯絡我們", content: "如對本隱私權政策有任何疑問，請聯絡：Medigreen LLC, 1411 Pale San Vitores Road, Suite 303, Tamuning, GU | 電子郵件：info@medigreen.energy | 電話：+1.671.482.0104" },
    ],
  },
  terms: {
    hero: {
      subtitle: "法律資訊",
      title: "使用條款",
      updated: "最後更新：2026年4月3日",
    },
    sections: [
      { title: "1. 接受條款", content: "透過存取和使用 Medigreen LLC 網站（「本網站」），您接受並同意受本使用條款的約束。如果您不同意這些條款，請勿使用本網站。" },
      { title: "2. 網站使用", content: "您只能將本網站用於合法目的。您同意不以任何違反適用法律法規的方式使用本網站，不傳輸有害或冒犯性內容，不嘗試未授權存取本網站的任何部分，或干擾本網站的正常運作。" },
      { title: "3. 智慧財產權", content: "本網站上的所有內容，包括文字、圖形、標誌和圖片，均為 Medigreen LLC 的財產，受適用智慧財產權法保護。未經我們明確書面許可，您不得複製、分發或創作衍生作品。" },
      { title: "4. 顧問服務免責聲明", content: "本網站提供的資訊僅供一般參考之用，不構成專業顧問、法律或財務建議。使用 Medigreen LLC 的顧問服務須另行簽訂書面協議。過去的表現不保證未來的結果。" },
      { title: "5. 責任限制", content: "在法律允許的最大範圍內，Medigreen LLC 對因使用本網站或依賴本網站提供的任何資訊而產生的任何間接、附帶、特殊、後果性或懲罰性損害不承擔責任。" },
      { title: "6. 保密性", content: "您透過本網站提交的任何資訊，包括詢問和諮詢請求，將受到嚴格保密處理。除法律要求外，未經您的同意，我們不會向第三方揭露您的資訊。" },
      { title: "7. 第三方連結", content: "本網站可能包含第三方網站的連結以方便您使用。Medigreen LLC 不認可或對任何第三方網站的內容、隱私政策或慣例承擔責任。" },
      { title: "8. 條款修改", content: "Medigreen LLC 保留隨時修改本使用條款的權利。變更將在發布到本網站後立即生效。您在任何變更後繼續使用本網站，即表示您接受修訂後的條款。" },
      { title: "9. 準據法", content: "本使用條款應受美國關島法律管轄並依其解釋，不考慮其法律衝突條款。" },
      { title: "10. 聯絡我們", content: "如對本使用條款有任何疑問，請聯絡：Medigreen LLC, 1411 Pale San Vitores Road, Suite 303, Tamuning, GU | 電子郵件：info@medigreen.energy | 電話：+1.671.482.0104" },
    ],
  },
};

export default pages;